// Shared atoms for all contract surfaces.
import { z } from 'zod';

// Generic error envelope. Worker errors are `{ error: <key>, ... }`;
// opaque 500s and parse-rejections also carry a short `ref` that links
// the client-visible error to the server log line.
export const ApiErrSchema = z.object({
  error: z.string(),
  ref: z.string().optional(),
});
export type ApiErr = z.infer<typeof ApiErrSchema>;
